import React from 'react';
import "./styles.css";
import {
    Typography,
} from "@mui/material";
import Tooltip from '@mui/material/Tooltip';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

export const TooltipComp = ({ values }) => {
    return (
        <Tooltip arrow
 
            componentsProps={{
                tooltip: {
                    sx: {
                        bgcolor: '#ffffff',
                        boxShadow: "0px 1px 6px #00000015",
                        borderRadius: '9px',
                        height:'140px'
                    },
                },
            }}
            style={{ background: '#FCFCFC' }} placement="bottom-start" title={
                <React.Fragment>
                  
                    <Typography style={{ color: '#000000', paddingBottom: "5px",  fontWeight: '600', letterSpacing: '2px' }}>Password Must:</Typography>
                    <li style={{ color: 'black',fontSize:'11px',  paddingBottom: "9px", letterSpacing: '2px' }}>Have at least one lower case character</li>
                    <li style={{ color: 'black',fontSize:'11px',  paddingBottom: "9px",  letterSpacing: '2px' }}>Have at least one upper case character</li>
                    <li style={{ color: 'black',fontSize:'11px',  paddingBottom: "9px",  letterSpacing: '2px' }}>Have at least one numeric value</li>
                    <li style={{ color: 'black',fontSize:'11px',  paddingBottom: "9px",  letterSpacing: '2px' }}>Have at least 8 characters</li>
                </React.Fragment>
            }>
            <InfoOutlinedIcon sx={{ marginLeft: '1%', marginTop: '4%' }} />
        </Tooltip>
    );
}